import { CompanyRuleDetailsOutputWithOutStatus } from './company-rule-details-output-with-out-status.model';


export class CompanyRuleDetailsSelectByIdOutput implements ICompanyRuleDetailsSelectByIdOutput {
    status!: number;
    message!: string;
    data!: CompanyRuleDetailsOutputWithOutStatus;

    constructor(data?: ICompanyRuleDetailsSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? CompanyRuleDetailsOutputWithOutStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyRuleDetailsSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRuleDetailsSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompanyRuleDetailsSelectByIdOutput {
    status: number;
    message: string;
    data: CompanyRuleDetailsOutputWithOutStatus;
}

